import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "warning", "form"]

  connect() {
    this.setOriginalValue()

    this._focusInputListener = this.focusInput.bind(this)
    this.formTarget.addEventListener('click', this._focusInputListener)
  }

  setOriginalValue() {
    this.originalValue = this.inputTarget.value
  }

  disconnect() {
    this.formTarget.removeEventListener('click', this._focusInputListener)
  }

  // Handle keyboard events
  //
  // Enter: Submit the form
  handleKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.submit()
    }
  }

  // Handle blur event - show warning if value changed but not saved
  handleBlur() {
    if (this.inputTarget.value !== this.originalValue) {
      this.showWarning()
    } else {
      this.hideWarning()
    }
  }

  // Handle focus event - hide warning when focused
  handleFocus() {
    this.hideWarning()
    this._isFocused = true
  }

  // Show warning triangle
  showWarning() {
    if (this.hasWarningTarget) {
      this.warningTarget.classList.remove('hidden')
    }
  }

  // Hide warning triangle
  hideWarning() {
    if (this.hasWarningTarget) {
      this.warningTarget.classList.add('hidden')
    }
  }

  submit() {
  // Submit the form
    const form = this.formTarget
    if (form) {
      form.requestSubmit()
      form.blur()
      this.hideWarning()
    }
  }

  focusInput() {
    if (document.activeElement === this.inputTarget) { return }
    if (this._isFocused) { return }
    this.inputTarget.focus()
    this.inputTarget.select()
    this._isFocused = true
  }
}
